import React, { useState } from 'react';
import Day from './Day';
import { FiArrowLeft, FiArrowRight } from "react-icons/fi"

const months = [
    { name: 'January', days: 31 },
    { name: 'February', days: 28 },
    { name: 'March', days: 31 },
    { name: 'April', days: 30 },
    { name: 'May', days: 31 },
    { name: 'June', days: 30 },
    { name: 'July', days: 31 },
    { name: 'August', days: 31 },
    { name: 'September', days: 30 },
    { name: 'October', days: 31 },
    { name: 'November', days: 30 },
    { name: 'December', days: 31 },
];

function WeekDay(props) {
    return (
        <div style={{ width: 40, height: 18 }}>
            <p style={{ textAlign: 'center', color: 'var(--ltg)' }}>{props.day}</p>
        </div>
    );
}
export default function Calendar(props) {
    const { date, setDate, onlyActive, eventDates, venueBookDates, myvenueBookDates, serBks } = props;
    const now = new Date();
    const [sel, setSel] = useState(now);
    const [days, setDays] = useState(null);
    function update(year, month) {
        const first = new Date(year, month, 1);
        const arr = [];
        for (let i = 0, d = 1; d <= months[month].days; i++) {
            if (first.getDay() > i) {
                arr.push({ key: i, day: 0 });
            } else {
                arr.push({ key: i, day: d });
                if (d === months[month].days) {
                    setDays(arr);
                }
                d++;
            }
        }
    }
    const [once, setOnce] = useState(true);
    if (once) {
        update(sel.getFullYear(), sel.getMonth());
        setOnce(false);
    }
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row', flexWrap: 'wrap',  }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr 1fr', alignItems: 'center', width: '100%', paddingBlock: 5, paddingInline: '10px' }}>
                <FiArrowLeft style={{color: 'var(--wht)', cursor: 'pointer', justifySelf: 'center'}}
                    onClick={() => {
                        const newSel = new Date(sel.valueOf() - (86400000 * months[sel.getMonth() == 0 ? 11 : sel.getMonth() - 1].days));
                        setSel(newSel);
                        update(newSel.getFullYear(), newSel.getMonth());
                    }}/>
                <p style={{color: 'var(--wht)', justifySelf: 'center'}}>{months[sel.getMonth()].name} {sel.getFullYear()}</p>
                <FiArrowRight style={{ color: 'var(--wht)', cursor: 'pointer', justifySelf: 'center'}}
                    onClick={() => {
                        const newSel = new Date(sel.valueOf() + (86400000 * months[sel.getMonth()].days));
                        setSel(newSel);
                        update(newSel.getFullYear(), newSel.getMonth());
                    }}/>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: 280 }}>
                <WeekDay day="Sun" />
                <WeekDay day="Mon" />
                <WeekDay day="Tue" />
                <WeekDay day="Wed" />
                <WeekDay day="Thu" />
                <WeekDay day="Fri" />
                <WeekDay day="Sat" />
                {days && days.map(item =>
                    // console.log('done')
                    <Day
                        key={item.key}
                        day={item.day}
                        date={date}
                        setDate={setDate}
                        sel={sel}
                        setSel={setSel}
                        onlyActive={onlyActive}
                        eventDates={eventDates}
                        venueBookDates={venueBookDates}
                        myvenueBookDates={myvenueBookDates}
                        serBks={serBks}
                    />
                )}
            </div>
        </div>
    );
}
